import { IAlarm } from "../../Models/IAlarm";
import { ISentinelRich } from "../../Models/ISentinel";
import { ISystemSetting } from "../../Models/ISystemSetting";
import { IUser, IUserMinimal } from "../../Models/IUser";

export const SET_USER = "SET_USER";
export const SET_USERS = "SET_USERS";
export const SET_SENTINELS = "SET_SENTINELS";
export const UPDATE_SENTINELS_FROM_ALARMS = "UPDATE_SENTINELS_FROM_ALARMS";
export const SET_SYS_SETTINGS = "SET_SYS_SETTINGS";
export const SET_AUDIO_ON_SENTINEL_INPUT = "SET_AUDIO_ON_SENTINEL_INPUT";
export const SET_AUDIO_ON_SENTINEL_OUTPUT = "SET_AUDIO_ON_SENTINEL_OUTPUT";
export const ADD_NEW_ALARM_WEBSOCKET = "ADD_NEW_ALARM_WEBSOCKET";
export const UPDATE_SENTINEL_SENSORS_WEBSOCKET = "UPDATE_SENTINEL_SENSORS_WEBSOCKET";

interface SetAudioOnSentinelInput {
  type: typeof SET_AUDIO_ON_SENTINEL_INPUT;
  payload: number;
}

interface SetAudioOnSentinelOutput {
  type: typeof SET_AUDIO_ON_SENTINEL_OUTPUT;
  payload: number;
}

interface SetUserType {
  type: typeof SET_USER;
  payload: IUser | undefined;
}

interface SetUsersType {
  type: typeof SET_USERS;
  payload: IUserMinimal[];
}

interface SetSentinelsType {
  type: typeof SET_SENTINELS;
  payload: ISentinelRich[];
}

interface SetSysSettingType {
  type: typeof SET_SYS_SETTINGS;
  payload: ISystemSetting[];
}

interface UpdateSentinelsFromAlarmsType {
  type: typeof UPDATE_SENTINELS_FROM_ALARMS;
  payload: IAlarm[];
}

interface AddNewAlarmWebSocketType {
  type: typeof ADD_NEW_ALARM_WEBSOCKET;
  payload: any;
}

interface UpdateSentinelSensorsWebSocketType {
  type: typeof UPDATE_SENTINEL_SENSORS_WEBSOCKET;
  payload: any;
}

export type GenericAction =
  | SetUserType
  | SetSentinelsType
  | SetUsersType
  | SetAudioOnSentinelInput
  | SetAudioOnSentinelOutput
  | SetSysSettingType
  | UpdateSentinelsFromAlarmsType
  | AddNewAlarmWebSocketType
  | UpdateSentinelSensorsWebSocketType;

const setUsers = (users: IUserMinimal[]): SetUsersType => {
  return { type: SET_USERS, payload: users };
};

const setVideoAudioInput = (sentinel: number): SetAudioOnSentinelInput => {
  return { type: SET_AUDIO_ON_SENTINEL_INPUT, payload: sentinel };
};

const setVideoAudioOutput = (sentinel: number): SetAudioOnSentinelOutput => {
  return { type: SET_AUDIO_ON_SENTINEL_OUTPUT, payload: sentinel };
};

const setUser = (user: IUser | undefined): SetUserType => {
  return { type: SET_USER, payload: user };
};

const setSentinels = (sentinels: ISentinelRich[]): SetSentinelsType => {
  return { type: SET_SENTINELS, payload: sentinels };
};

const setSysSettings = (settings: ISystemSetting[]): SetSysSettingType => {
  return { type: SET_SYS_SETTINGS, payload: settings };
};

const updateSentinelsFromAlarms = (alarms: IAlarm[]): UpdateSentinelsFromAlarmsType => {
  return { type: UPDATE_SENTINELS_FROM_ALARMS, payload: alarms };
};

const addNewAlarmFromWebSocket = (alarmData: any): AddNewAlarmWebSocketType => {
  return { type: ADD_NEW_ALARM_WEBSOCKET, payload: alarmData };
};

const updateSentinelSensorsFromWebSocket = (sensorData: any): UpdateSentinelSensorsWebSocketType => {
  return { type: UPDATE_SENTINEL_SENSORS_WEBSOCKET, payload: sensorData };
};

export const GenericActions = {
  setUser,
  setSentinels,
  setUsers,
  setSysSettings,
  setVideoAudioInput,
  setVideoAudioOutput,
  updateSentinelsFromAlarms,
  addNewAlarmFromWebSocket,
  updateSentinelSensorsFromWebSocket,
};
